/** Shared helpers for instant bank collection (Plaid + Financial Connections). */

/** localStorage key — set by OAuth return tab; storage event wakes the opener tab. */
export const FC_OAUTH_HANDOFF_KEY = 'fc_oauth_handoff';

/** postMessage type — OAuth return tab → opener tab. */
export const FC_OAUTH_MESSAGE_TYPE = 'gg_fc_oauth_complete';

export const ACH_MANDATE_TEXT =
    'By clicking "Connect bank account", you authorize Greatest Gift to debit the bank account ' +
    'you connect for any amount owed for charges arising from your use of Greatest ' +
    "Gift's services, pursuant to Greatest Gift's website and terms, until this " +
    'authorization is revoked. You may amend or cancel this authorization at any time ' +
    'by providing notice to Greatest Gift with 30 (thirty) days notice. Payments are ' +
    'processed by our partner, Stripe.';

export function preparePlaidOauthStorage(save_gift_for_oauth) {
    save_gift_for_oauth();
    localStorage.setItem('gifting_url', JSON.stringify(window.location.href));
    localStorage.setItem('oauth_flow', JSON.stringify('pm'));
}

export function prepareFcOauthStorage(save_gift_for_oauth, clientSecret, setupIntentId) {
    save_gift_for_oauth();
    localStorage.setItem('fc_gifting_url', JSON.stringify(window.location.href));
    localStorage.setItem('fc_oauth_flow', JSON.stringify('pm'));
    localStorage.setItem('fc_client_secret', JSON.stringify(clientSecret));
    if (setupIntentId) {
        localStorage.setItem('fc_setup_intent_id', JSON.stringify(setupIntentId));
    }
}

export function cleanupPlaidOauthStorage(cleanupOauth) {
    localStorage.removeItem('plaid_link_token');
    localStorage.removeItem('gift');
    localStorage.removeItem('gifting_url');
    localStorage.removeItem('oauth_flow');
    if (cleanupOauth) {
        cleanupOauth();
    }
}

export function cleanupFcOauthStorage(cleanupFcOauth) {
    localStorage.removeItem('fc_client_secret');
    localStorage.removeItem('fc_setup_intent_id');
    localStorage.removeItem('fc_gifting_url');
    localStorage.removeItem('fc_oauth_flow');
    localStorage.removeItem(FC_OAUTH_HANDOFF_KEY);
    localStorage.removeItem('gift');
    if (cleanupFcOauth) {
        cleanupFcOauth();
    }
}

export function readStoredFcClientSecret() {
    try {
        return JSON.parse(localStorage.getItem('fc_client_secret') || 'null');
    } catch (e) {
        return null;
    }
}

export function readStoredFcSetupIntentId() {
    try {
        return JSON.parse(localStorage.getItem('fc_setup_intent_id') || 'null');
    } catch (e) {
        return null;
    }
}

/** Notify the opener tab that bank OAuth finished (popup / second-tab case). */
export function signalFcOauthHandoffToOpener() {
    localStorage.setItem(FC_OAUTH_HANDOFF_KEY, String(Date.now()));
    if (window.opener && !window.opener.closed) {
        window.opener.postMessage({ type: FC_OAUTH_MESSAGE_TYPE }, window.location.origin);
        window.opener.focus();
    }
}

/**
 * OAuth return landed in a popup/second tab — hand off to opener and close this window.
 * Returns true when handoff was attempted (same-tab OAuth should return false).
 */
export function tryHandoffFcOauthToOpener() {
    if (!window.opener || window.opener.closed) {
        return false;
    }
    signalFcOauthHandoffToOpener();
    window.close();
    return true;
}

export function resetInstantBankUiState(setState) {
    setState({
        loading: false,
        method_type: '',
        verification: '',
        account_number: '',
        routing_number: '',
        new_manual_bank: {},
        overlay_open: false,
        save_method: true,
        plaid_link_token: '',
        plaid_session: '',
    });
}

export function finishInstantBankAdd({ response, bankNext, setState, cleanupFn }) {
    resetInstantBankUiState(setState);
    bankNext(response.new_pm);
    if (cleanupFn) {
        cleanupFn();
    }
}
